// extracted by mini-css-extract-plugin
export var aiStarSpin = "_n4-1";
export var spinner = "_n4-0";